import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function SyllabusMath() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="mathematics" type="syllabus" book="" />

    </>
  );
}

export default SyllabusMath;  